import type { ExperienceProfile } from '@nava/backoffice-bff-contracts';
export function ExperienceProfileSelection({
  label,
  value,
  profiles,
  disabled,
  onChange,
}: {
  label: string;
  value: string | null;
  profiles: ExperienceProfile[];
  disabled: boolean;
  onChange: (value: string | null) => void;
}) {
  return (
    <label className="block">
      {label}
      <select
        className="ml-3 rounded border p-2"
        disabled={disabled}
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value || null)}
      >
        <option value="">Product-line defaults only</option>
        {value && !profiles.some((profile) => profile.id === value) && (
          <option value={value} disabled>
            Unavailable profile
          </option>
        )}
        {profiles
          .filter((p) => p.status === 'active' || p.id === value)
          .map((p) => (
            <option key={p.id} value={p.id} disabled={p.status !== 'active'}>
              {p.name}
              {p.status === 'archived' ? ' (archived)' : ''}
            </option>
          ))}
      </select>
    </label>
  );
}
